// extracted by mini-css-extract-plugin
module.exports =  {"label":"label___izbxl"};